
export const AppMainModules = {
  maintenance: "maintenance",
  inventoryManagement: "inventory-management",
  tripManagement: "trip-management",
  fuelManagement: "fuel-management",
  operations: "operations",
  assetsManagement: "assets-management",
  customers: "customers",
  finance: "finance",
  contract: "contract",
  fmcr: "fmcr",
}

export const FMCRSubModules = {
  FMCR: "fmcr",
  VehicleTracking: "vehicle-tracking",
}

export const FMCRPermission = {
  VehicleTracking: "vehicle-tracking",
  ViewTracking: "view-tracking",
  ViewReport: "view-report",
  CreateReport: "create-report",
  Tracking: "tracking",
  Reports: "reports",
  TrackSelectedVehicles: "track-selected-vehicles",
  SeeFullDetails: "see-full-details",
};

export const InventorySubModules = {
  Parts: "parts",
  Procurement: "procurement",
  Vendor: "vendor",
  Warehouse: "warehouse",
}

export const MaintinaceSubModules = {
  Dashboard: "dashboard",
  Services: "services",
  Issue: "issue",
  WorkOrders: "work-orders",
  Categories: "categories",
  VehicleType: "vehicle-type",
  PartModels: "part-models",
  PartMakes: "part-makes",
}

export const TripSubModules = {
  Trips: "trips",
  TripsList: "trips-list",
  FuelRequests: "fuel-requests",
  PettyCash: "petty-cash",
  TripExpense: "trip-expenses",
}

export const TripsStageEnum = {
  Created: 'created',
  TripStops: 'trip-stops',
  ChecklistsAndAllocations: 'checklists-and-allocations',
  InTransit: 'in_transit',
  Unverified: 'unverified',
  Correction: 'correction',
  Verified: 'verified',
  Closed: 'closed',
  Completed: 'completed',
}

export const FuelSubModules = {
  Fuel: "fuel",
  FuelStations: "fuel-stations",
  FuelRequests: "fuel-requests",
}

export const OperationsSubModules = {
  DriverSafety: "driver-safety",
}

export const AssetsSubModules = {
  Assets: "assets",
}

export const CustomersSubModules = {
  Customers: "customers",
}

export const FinanceSubModules = {
  Dashboard: "finance-dashboard",
  TripCostEstimation: "trip-cost-estimation",
  DriverExpense: "expenses",
  DriverPayments: "driver-payments",
  Payroll: "payroll",
  PricingTemplates: "pricing-templates",
  Invoices: "invoices",
  FinancialReports: "financial-reports",
  Reports: "finance-reports",
  Settings: "finance-settings",
}


export const ProcurementPermission = {
  CreateRfq: "create-rfq",
  UpdateRfq: "update-rfq",
  DeleteRfq: "delete-rfq",
  ViewRfq: "view-rfq",
  RfqSupplyChainApproval: "rfq-supply-chain-approval",
  CreatePo: "create-po",
  UpdatePo: "update-po",
  DeletePo: "delete-po",
  ViewPo: "view-po",
}


export const VendorAndWarehousePermission = {

  CreateVendor: "create",
  UpdateVendor: "update",
  DeleteVendor: "delete",
  ViewVendor: "view",
  CreateWarehouse: "create",
  UpdateWarehouse: "update",
  DeleteWarehouse: "delete",
  ViewWarehouse: "view",

}
export const PartsPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const TripPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
  // Stages
  Created: "created",
  TripStops: "trip-stops",
  ChecklistsAndAllocations: "checklists-and-allocations",
  ReadyToDispatch: "ready-to-dispatch",
  InTransit: "in-transit",
  Correction: "correction",
  ReturnToCorrection: "return-to-correction",
  Unverified: "unverified",
  Verified: "verified",
  Verify: "verify",
  Completed: "completed",
  Closed: "closed",
  Approved: "approved",
  // Petty Cash
  PettyCashAdd: "petty-cash-add",
  PettyCashView: "petty-cash-view",
  PettyCashEdit: "petty-cash-edit",
  PettyCashDelete: "petty-cash-delete",
  PettyCashExportPdf: "petty-cash-export-pdf",
  PettyCashExportExcel: "petty-cash-export-excel",
  PettyCashStatusUpdate: "petty-cash-approval-status",
  PettyCashApprovalStatus: "petty-cash-approval-status",
  // Fuel Request
  FuelRequestView: "fuel-request-view",
  FuelRequestEdit: "fuel-request-edit",
  FuelRequestDelete: "fuel-request-delete",
  FuelRequestStatusUpdate: "fuel-request-approval-status",
  // Fuel Logs
  FuelLogsAdd: "fuel_logs-add",
  FuelLogsView: "fuel_logs-view",
  FuelLogsEdit: "fuel_logs-edit",
  FuelLogsDelete: "fuel_logs-delete",
  // Expenses
  ExpensesAdd: "expenses-add",
  ExpensesView: "expenses-view",
  ExpensesEdit: "expenses-edit",
  ExpensesDelete: "expenses-delete",
  TripExpenseExportPdf: "trip-expense-export-pdf",
  TripExpenseExportExcel: "trip-expense-export-excel",
  // Trip Start
  TripStart: "trip-start",
  UnverifiedStartTrip: "checklist-approval-trip",
  ResetTrip: "reset-trip",
  // Reports / PDFs
  FuelSheet: "fuel-sheet",
  Builty: "Builty",
  Bilty: "bilty",
  POD: "POD",
  Pod: "pod",
};

export const FuelPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const FuelStationPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const DriverSafetyPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
  StatusApproval: "status-approval",
}

export const AssetsPermission = {
  CreateVehicle: "create-vehicle",
  UpdateVehicle: "update-vehicle",
  DeleteVehicle: "delete-vehicle",
  ViewVehicle: "view-vehicle",
  CreateEquipment: "create-equipment",
  UpdateEquipment: "update-equipment",
  DeleteEquipment: "delete-equipment",
  ViewEquipment: "view-equipment",
  CreateTyre: "create-tyre",
  UpdateTyre: "update-tyre",
  DeleteTyre: "delete-tyre",
  ViewTyre: "view-tyre",
}

export const CustomersPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const FinancePermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const ContractPermission = {
  Create: "create",
  Update: "update",
  Delete: "delete",
  View: "view",
}

export const ReportsPermission = {
  CreatePnl: "create-pnl",
  ViewPnl: "view-pnl",
  DownloadPnl: "download-pnl",
  CreateAr: "create-ar",
  ViewAr: "view-ar",
  DownloadAr: "download-ar",
}

export const DashboardPermission = {
  View: "view",
  Export: "export",
}

export const ServicesPermission = {
  View: "view",
  Create: "create",
  Delete: "delete",
}

export const IssuePermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
  Export: "export",
}

export const WorkOrdersPermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
  FinanceApproval: "finance-approval",
  OperationsApproval: "operations-approval",
  Export: "export",
}

export const CategoriesPermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
}

export const VehicleTypePermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
}

export const PartModelsPermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
}

export const PartMakesPermission = {
  View: "view",
  Create: "create",
  Update: "update",
  Delete: "delete",
}

export const INVOICE_TYPES = {
  MONTHLY: "monthly",
  WEEKLY: "weekly",
  AD_HOC: "ad_hoc",
};
